module.exports = __webpack_public_path__ + "img/br.c0726e3d.svg";